export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const MONTH_NAMES_PT = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
  "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"];

export const WEEKDAY_SHORT = ["Seg", "Ter", "Qua", "Qui", "Sex", "Sáb", "Dom"];

export const FREQ_LABEL = {
  daily: "Diária",
  weekdays: "Dias úteis",
  weekend: "Fim de semana",
  weekly: "Semanal",
  monthly: "Mensal",
};

export const FREQ_ORDER = ["daily", "weekdays", "weekend", "weekly", "monthly"];

export function daysInMonth(year, month) {
  return new Date(year, month, 0).getDate();  // month: 1-12
}
